import React from 'react';
import './Layout.css';

const Footer = () => {
  const isLocalEnv = process.env.REACT_APP_API_URL && 
                  process.env.REACT_APP_API_URL.includes('localhost');
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <span className="logo-icon">🔐</span>
            <span className="logo-text">zkVox</span>
            {isLocalEnv && <span className="env-badge">LOCAL</span>}
          </div>
          
          <div className="footer-info">
            <p>Secure voting with zero-knowledge proofs</p>
            <p className="copyright">&copy; {new Date().getFullYear()} zkVox. Created by <a href="https://gabrielrondon.com" target="_blank" rel="noopener noreferrer">Gabriel Rondon</a> using Noir and open-sourced.</p>
          </div>
          
          <div className="footer-links">
            <a href="https://github.com/gabrielrondon/zkvote" target="_blank" rel="noopener noreferrer">GitHub</a>
            <button 
              className="footer-link-button" 
              onClick={() => alert('Documentation coming soon!')}
            >
              Documentation
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;